// src/components/atoms/Avatar/Avatar.tsx
import React from 'react';

import '@/components/atomic/Avatar/Avatar.scss';

interface AvatarProps {
  initials: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ initials, size = 'md', className = '' }) => (
  <span className={`avatar avatar--${size} ${className}`.trim()}>
    {initials}
  </span>
);

export default Avatar;
